module.exports = __webpack_public_path__ + "static/media/inbuiltFunction.bd63f3ae.PNG";